export default __webpack_public_path__ + "static/media/charles.aaca4155.png";